import { Environment } from './interface'

export const environment: Environment = {
  production: false,
  baseUrl: 'https://a100to1-dev.firmfreez.ru/admin/',
}
